'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/apps/BopApp/views/BopPaymentView/BopPaymentView.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analytics = require('shared/lib/analytics');

var analytics = _interopRequireWildcard(_analytics);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _isBoolean = require('lodash/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _PaymentLayout = require('shared/lib/components/PaymentLayout');

var _PaymentLayout2 = _interopRequireDefault(_PaymentLayout);

var _LineItemsList = require('shared/lib/components/LineItemsList');

var _LineItemsList2 = _interopRequireDefault(_LineItemsList);

var _SectionWrapper = require('shared/lib/components/SectionWrapper');

var _SectionWrapper2 = _interopRequireDefault(_SectionWrapper);

var _bop_details = require('../../bop_details.json');

var _bop_details2 = _interopRequireDefault(_bop_details);

var _utils = require('shared/lib/utils');

require('./BopPaymentView.css');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  disclaimer: _propTypes2.default.string,
  submitPurchase: _propTypes2.default.func,
  selectedPlan: _propTypes2.default.object,
  checkoutInfo: _propTypes2.default.shape({
    currency_code: _propTypes2.default.string,
    items: _propTypes2.default.array,
    payment_frequency: _propTypes2.default.string,
    tax_percentage: _propTypes2.default.number,
    totals: _propTypes2.default.shape({
      subtotal: _propTypes2.default.number,
      grandtotal: _propTypes2.default.number
    })
  }),
  isInProgress: _propTypes2.default.bool
};
var defaultProps = {
  disclaimer: null,
  isInProgress: false
};

var BopPaymentView = function (_Component) {
  _inherits(BopPaymentView, _Component);

  function BopPaymentView() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BopPaymentView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BopPaymentView.__proto__ || Object.getPrototypeOf(BopPaymentView)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (_ref2) {
      var cardElement = _ref2.cardElement;

      _this.props.submitPurchase(cardElement).then(function () {
        _this.props.navTo((0, _utils.resolveUrlPath)('confirmation'));
      }).catch(_this.props.onError);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BopPaymentView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      analytics.page('BOP - Payment');
      analytics.track('Checkout Step Viewed', {
        category: 'order',
        step: 2
      });
    }
  }, {
    key: 'detailsFor',
    value: function detailsFor(detailName) {
      var planDetails = _bop_details2.default[this.planCode][detailName];

      if ((0, _isBoolean2.default)(planDetails.title)) {
        if (planDetails.title) {
          return 'Included';
        }
      } else {
        return planDetails.title;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: 'BopPaymentView Container Container--small',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 140
        },
        __self: this
      }, _react2.default.createElement(_PaymentLayout2.default, {
        title: 'Your Quote for ' + (0, _get3.default)(this.props.details, 'business_name'),
        icon: 'store_mall_directory',
        isPurchaseInProgress: this.props.isInProgress,
        totals: this.props.checkoutInfo.totals,
        acknowledgmentHtml: (0, _get3.default)(this.props.selectedPlan, 'information.acknowledgment_html'),
        billingCycle: 'year',
        policyStartDate: this.props.policyStartDate,
        disclaimer: this.props.disclaimer,
        onSubmit: this.handleSubmit,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 141
        },
        __self: this
      }, _react2.default.createElement(_SectionWrapper2.default, {
        title: 'Business details',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 155
        },
        __self: this
      }, _react2.default.createElement(_LineItemsList2.default, {
        rows: [['Type', this.businessType], ['Business name', this.props.details.business_name], ['Primary contact', [this.props.details.pni_first_name, this.props.details.pni_last_name].join(' ')], ['Address', this.businessAddress], ['Entity', this.businessEntityName]],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156
        },
        __self: this
      })), _react2.default.createElement(_SectionWrapper2.default, {
        title: 'Coverage details',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 172
        },
        __self: this
      }, _react2.default.createElement(_LineItemsList2.default, {
        rows: this.coverageDetailsRows,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173
        },
        __self: this
      }))));
    }
  }, {
    key: 'coverageDetailsRows',
    get: function get() {
      var rows = [['Underwritten By', 'Chubb'], ['Plan', (0, _get3.default)(this.props.selectedPlan, 'information.title')], ['Coverage term', _react2.default.createElement('span', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        },
        __self: this
      }, 'From ' + this.props.policyStartDate.format('MMM DD, YYYY'), _react2.default.createElement('br', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        },
        __self: this
      }), 'to ' + (0, _momentTimezone2.default)(this.props.policyStartDate).add(1, 'year').format('MMM DD, YYYY'))], ['General liability', this.detailsFor('general_liability')], ['Business personal property', this.detailsFor('business_personal_property')], ['Additional insured', this.detailsFor('additional_insured_coverage')], ['Lost business income', this.detailsFor('lost_business_income')], ['Employee liability coverage', this.detailsFor('employee_liability_coverage')], ['Hired and non-owned auto', this.detailsFor('hired_and_non_owned_auto')]];
      return (0, _filter2.default)(rows, function (row) {
        return !!row[1];
      });
    }
  }, {
    key: 'businessType',
    get: function get() {
      var businessClassCode = this.props.details.business_class_code;
      var businessClass = (0, _find2.default)(this.props.businessClasses, {
        code: businessClassCode
      });
      return (0, _get3.default)(businessClass, 'name');
    }
  }, {
    key: 'businessAddress',
    get: function get() {
      return _react2.default.createElement('span', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: this
      }, this.props.ratingAddress.streetAddress, _react2.default.createElement('br', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 112
        },
        __self: this
      }), this.props.ratingAddress.unit && [this.props.ratingAddress.unit, _react2.default.createElement('br', {
        key: 'unit-br',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      })], this.props.ratingAddress.city, ' ', this.props.ratingAddress.region, ',', ' ', this.props.ratingAddress.postal);
    }
  }, {
    key: 'businessEntityName',
    get: function get() {
      var screen = (0, _find2.default)(this.props.screens, function (screen) {
        return (0, _find2.default)(screen.fields, {
          key_name: 'business_legal_nature'
        });
      });
      var field = (0, _find2.default)(screen.fields, {
        key_name: 'business_legal_nature'
      });
      var choice = (0, _find2.default)(field.settings.choices, {
        value: this.props.details.business_legal_nature
      });
      return (0, _get3.default)(choice, 'title');
    }
  }, {
    key: 'planCode',
    get: function get() {
      return (0, _get3.default)(this.props.selectedPlan, 'details.chubb_plan_code');
    }
  }]);

  return BopPaymentView;
}(_react.Component);

BopPaymentView.propTypes = propTypes;
BopPaymentView.defaultProps = defaultProps;
exports.default = BopPaymentView;